import React from "react";
import "./read-only-sections.scss";

export const HeaderSection = ({ label }) => {
    return <div className="read-only__header">{label}</div>;
};
